import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export const TableTitleContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(3),
}));
